import { CoreFetch, isTabletPortraitDown, MeApi, Spinner } from '@enter/core';
import { mdiArrowLeft } from '@mdi/js';
import { Icon } from '@mdi/react';
import React, { useContext, useState } from 'react';
import { DialogContext } from '../../../../services/dialog/context';
import { ToastContext } from '@enter/core';
import * as S from '../shared.styles';

export const SecurityAndSafety: React.FC = () => {
    const toastContext = useContext(ToastContext);
    const dialogContext = useContext(DialogContext);
    const [loadingPassword, setLoadingPassword] = useState(false);
    const [loading2FA, setLoading2FA] = useState(false);

    const handleResetPassword = async (): Promise<void> => {
        setLoadingPassword(true);
        try {
            const response = await CoreFetch<MeApi>(MeApi).authPasswordResetUrl();
            if (response.url) {
                window.open(response.url, '_blank');
            }
        } catch (err) {
            dialogContext.showError(err as Error);
        } finally {
            setLoadingPassword(false);
        }
    };

    const handleReset2FA = async (): Promise<void> => {
        setLoading2FA(true);
        try {
            await CoreFetch<MeApi>(MeApi).auth2faReset();
            toastContext.notify?.(
                'Your Two Factor Device Has Been Reset - The next time you log-in you will be prompted to set up a new two factor device.',
                'right'
            );
        } catch (err) {
            dialogContext.showError(err as Error);
        } finally {
            setLoading2FA(false);
        }
    };

    return (
        <S.SubCategoryRow>
            <S.SubCategoryCol>
                <S.SubCategoryHeader>
                    {isTabletPortraitDown() && (
                        <S.ReturnLink to="/settings">
                            {(): React.ReactElement => <Icon path={mdiArrowLeft} size={1} />}
                        </S.ReturnLink>
                    )}
                    <S.SubCategoryH1>Security & Safety</S.SubCategoryH1>
                </S.SubCategoryHeader>
                <S.SubCategoryItem>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <S.Button
                            variant="primary"
                            onClick={handleResetPassword}
                            disabled={loadingPassword || loading2FA}
                        >
                            {loadingPassword ? <Spinner size="20px" /> : 'Reset Password'}
                        </S.Button>
                        <S.Button
                            variant="primary"
                            onClick={handleReset2FA}
                            disabled={loadingPassword || loading2FA}
                        >
                            {loading2FA ? <Spinner size="20px" /> : 'Reset Two Factor Authentication'}
                        </S.Button>
                    </div>
                </S.SubCategoryItem>
            </S.SubCategoryCol>
        </S.SubCategoryRow>
    );
};
